import styled, { css } from 'styled-components';
import * as Styled from './CustombarComp';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/image/emmausi_logo.png';
import { SidebarMajorList, SidebarMinorList } from '../@const/sidebarMenu';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store/modules';
import { BiArrowFromRight, BiArrowFromLeft } from 'react-icons/bi';
import {
  setSidebarOpenedCategories,
  setSidebarUiStatus,
  SidebarState,
  toggleSidebar,
} from '../store/modules/sidebar';
import { toggleCustombar } from '../store/modules/customBar';
import { Board } from './CustombarComp/Board';
import React from 'react';

const CustombarComponent = () => {
  const dispatch = useDispatch();

  // Redux 상태만 의존하도록 shallowEqual을 활용
  const { mode, open } = useSelector((state: RootState) => state.custombar);

  const CompProvider = () => {
    return mode === 'BOARD' ? <Board /> : null;
  };

  return (
    <Styled.Container $open={open}>
      <Styled.Sidebar>
        <CompProvider />
      </Styled.Sidebar>
    </Styled.Container>
  );
};

// 부모 컴포넌트가 리렌더링되어도 Custombar가 영향을 받지 않도록 memo 적용
export const Custombar = React.memo(CustombarComponent);
